export class TypeUtils {
    public static toBoolean = (value: any): boolean => {
        const stringValue = value?.toString().toLowerCase();

        if (stringValue === '1' || stringValue === 'true') return true;

        return false;
    };
}
